export const useModalCategoryRouter = () => {
  const modalRouter = useModalRouter();

  const categorySlug = computed(() => {
    return modalRouter.hashModalIds.value[0] ?? null;
  });

  const contentSlug = computed(() => {
    return modalRouter.hashModalIds.value[1] ?? '';
  });

  const childSlug = computed(() => {
    return modalRouter.hashModalIds.value[2] ?? '';
  });

  return {
    ...modalRouter,
    categorySlug,
    contentSlug,
    childSlug,
  };
};
